export default "__VITE_ASSET__CfG1jffO__"